import script from "./MembersInfoPage.vue?vue&type=script&setup=true&lang=js"
export * from "./MembersInfoPage.vue?vue&type=script&setup=true&lang=js"

import "./MembersInfoPage.vue?vue&type=style&index=0&id=0410d4fe&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0410d4fe"]])

export default __exports__